import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getAuthorized } from "@/lib/fetch";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export function useStrategyCurrency(
  rawStrategyId: string | number | null | undefined,
) {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage?.startsWith("fr") ? "fr" : "en";

  const strategyId =
    typeof rawStrategyId === "number" ? rawStrategyId : Number(rawStrategyId);
  const enabled = Number.isFinite(strategyId) && strategyId > 0;

  const { data } = useQuery({
    queryKey: [
      Clients.S1_QUANTILIA,
      Tables.S1_POSITIONS,
      "strategy-currency",
      strategyId,
      language,
    ],
    queryFn: async () => {
      const res = await getAuthorized(
        `${import.meta.env.VITE_BACKEND_URL}/${Clients.S1_QUANTILIA}/${Tables.S1_POSITIONS}/strategy-currency/${strategyId}?language=${language}`,
      );
      if (!res.ok) {
        throw new Error(
          `Unable to load currency for strategy ${strategyId}`,
        );
      }
      return res.json();
    },
    enabled,
  });

  return enabled ? (data?.currency ?? null) : null;
}
